import { render, staticRenderFns } from "./PostActions.vue?vue&type=template&id=412ebb81&"
import script from "./PostActions.vue?vue&type=script&lang=js&"
export * from "./PostActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports